export default __webpack_public_path__ + "static/FarmaciaChavez-54aa588299e8791b774591f123abf071.png";